module.exports = __webpack_public_path__ + "media/sessions/meetup@3x-2236f6c6.png";